// Mock in-memory store (page refresh pannina reset aagum). Backend vandha DB-ku maathuvom.
const events = [];
let nextId = 1;
let settings = {
  autoSend: false,
  delay: 'immediate',
  message: 'Hi {name}, thank you for visiting us. 🙏\nHow was your experience? Please rate us in 10 seconds:\n{link}',
};

const phoneKey = (p) => String(p || '').replace(/\D/g, '').slice(-10);
const ICONS = { appointment: '📅', status: '🔄', survey: '📋', feedback: '⭐', message: '💬' };

export function pushLeadEvent({ phone, name, type, text }) {
  events.unshift({ id: nextId++, phone: phoneKey(phone), name: String(name || '').trim().toLowerCase(), type, icon: ICONS[type] || '•', text, ts: Date.now() });
}

export function getLeadEvents(lead) {
  const pk = phoneKey(lead && lead.phone);
  const nm = String((lead && lead.name) || '').trim().toLowerCase();
  return events.filter(e => (pk && e.phone === pk) || (nm && e.name === nm));
}

export const getSurveySettings = () => settings;
export const setSurveySettings = (s) => { settings = { ...settings, ...s }; };

export function renderSurveyMessage(tpl, vars) {
  return String(tpl || '')
    .replace(/\{name\}/g, vars.name || 'Customer')
    .replace(/\{product\}/g, vars.product || '')
    .replace(/\{link\}/g, vars.link || '');
}
